const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

/**
 * Returns `true` when the app is running on localhost (e.g. `npm start`,
 * Cypress against the local server). Used to keep dev navigation on the
 * local origin rather than jumping to absolute backend-provided URLs.
 */
export function isLocalhost(): boolean {
  if (typeof window === 'undefined') return false;
  return LOCALHOST_HOSTNAMES.has(window.location.hostname);
}
